/* BW Wishlist · favoritos nativos del tema (localStorage), sin apps. Sustituye a la app «Wishlist» de Vitals.
   Mismo patrón que sk-wishlist.js (SOKA) / bs-wishlist.js (Bienestar Senior).

   Botones: cualquier elemento .bw-fav-btn con data-product-handle (+ data-product-id, data-variant-id).
   Estado:  localStorage 'hk_wishlist' = [{ h: handle, p: productId, v: variantId, t: timestamp }].
   Visual:  clase .is-wishlist + aria-pressed. Contador: cualquier [data-bw-wishlist-count].
   Evento:  'bw:wishlist:change' (detail.count). API: window.BWWishlist { read, has, remove, apply }. */
(function () {
  'use strict';

  var KEY = 'hk_wishlist';

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(a) ? a : [];
    } catch (e) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* cuota / modo privado */ }
    document.dispatchEvent(new CustomEvent('bw:wishlist:change', { bubbles: true, detail: { count: list.length } }));
  }

  function indexOf(list, handle) {
    for (var i = 0; i < list.length; i++) if (list[i] && list[i].h === handle) return i;
    return -1;
  }

  function setBtnState(btn, saved) {
    btn.classList.toggle('is-wishlist', saved);
    btn.setAttribute('aria-pressed', String(saved));
    var label = saved ? 'Quitar de favoritos' : 'Guardar en favoritos';
    btn.setAttribute('title', label);
    if (btn.dataset.productTitle) btn.setAttribute('aria-label', label + ': ' + btn.dataset.productTitle);
  }

  function applyAll() {
    var list = read();
    document.querySelectorAll('.bw-fav-btn[data-product-handle]').forEach(function (btn) {
      setBtnState(btn, indexOf(list, btn.dataset.productHandle) !== -1);
    });
  }

  function updateCount(n) {
    document.querySelectorAll('[data-bw-wishlist-count]').forEach(function (el) {
      el.textContent = String(n);
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function pulse(btn) {
    btn.classList.remove('is-pulsing');
    requestAnimationFrame(function () { btn.classList.add('is-pulsing'); });
    setTimeout(function () { btn.classList.remove('is-pulsing'); }, 420);
  }

  function toggle(btn) {
    var handle = btn.dataset.productHandle;
    if (!handle) return;
    var list = read();
    var i = indexOf(list, handle);
    var saved;
    if (i === -1) {
      list.push({ h: handle, p: btn.dataset.productId || '', v: btn.dataset.variantId || '', t: Date.now() });
      saved = true;
    } else {
      list.splice(i, 1);
      saved = false;
    }
    write(list);
    var sel = '.bw-fav-btn[data-product-handle="' + handle.replace(/"/g, '\\"') + '"]';
    document.querySelectorAll(sel).forEach(function (b) { setBtnState(b, saved); pulse(b); });
    updateCount(list.length);
  }

  /* Click delegado: vale para tarjetas cargadas después (cargar más, recomendados, favoritos) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bw-fav-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  function init() { applyAll(); updateCount(read().length); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('bw:wishlist:change', function (e) { updateCount(e && e.detail ? e.detail.count : read().length); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) init(); });

  window.BWWishlist = {
    read: read,
    has: function (handle) { return indexOf(read(), handle) !== -1; },
    remove: function (handle) { var l = read(); var i = indexOf(l, handle); if (i !== -1) { l.splice(i, 1); write(l); applyAll(); } },
    apply: applyAll
  };
})();
